import { render, staticRenderFns } from "./QuickStartMD.vue?vue&type=template&id=5e3857df&scoped=true"
import script from "./QuickStartMD.vue?vue&type=script&lang=js"
export * from "./QuickStartMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3857df",
  null
  
)

export default component.exports